<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="130px">
        <el-row :gutter="24">
          

          <el-col :span="24">
            <el-form-item label="监控名称" prop="monitorName">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.monitorName"
                placeholder="请输入监控名称"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" >
            <el-form-item label="监控部署区域" prop="areaId" >
              <areaTree
              :areaName.sync="form.areaName"
               :projectId="projectId"
                :disabled="model === 'view'"
                :areaId.sync="form.areaId"
                placeholder="请选择 区域名称"
              ></areaTree>
            
              
           
           
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="设备编号" prop="deviceNo">
              <el-input
                clearable
                :disabled="model === 'view'"
                
                v-model="form.deviceNo"
              
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="通道编号" prop="passageNo">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.passageNo"
                maxlength="50"
              
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="监控流地址" prop="url">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.url"
                maxlength="200"
              
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="网页播放地址" prop="httpUrl">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.httpUrl"
                maxlength="200"
              
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model === 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
    
  </div>
</template>
<script>
import { getDictionary } from '@/api/common.js';
import { getProjectList,monitorvideosubmit,monitorvideoupdate} from '@/api/call-system/video/index';

import areaTree from "./area-tree.vue"
export default {
  components: { areaTree },
  props: {
    row: {
      default: {},
    },
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectId:'',
      form: {
        monitorName: '',
        areaId: '',
        areaName: '',
        deviceNo: '',
        passageNo:'',
        url:'',
        httpUrl:'',
      },
      formRules: {
        areaId: [{ required: true, message: '监控部署区域不能为空', trigger: 'change' }],
        deviceNo: [{ required: true, message: '设备编号不能为空', trigger: 'blur' }],
        monitorName: [{ required: true, message: '监控名称不能为空', trigger: 'blur' }],
        passageNo: [{ required: true, message: '通道不能为空', trigger: 'blur' }],
        url: [{ required: true, message: '监控流地址不能为空', trigger: 'blur' }],
        httpUrl: [{ required: true, message: '网页播放地址不能为空', trigger: 'blur' }],
      },
     
    };
  },
  created() {
    
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    
    
    async initData() {
     await getProjectList().then((res)=>{
        this.projectId =res.data[0].id
      })
      getDictionary("sex").then(res=>{
        this.sexList = res.data
      })
      
      if (this.model !== 'add') {
        this.form = Object.assign({},this.row)
        console.log(this.form)
      }else{
       
      }

     
    },
    saveRecord() {
      if (this.model === 'add') {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            monitorvideosubmit(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }
        });
      } else {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            monitorvideoupdate(this.form).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
